/**
 * A tall apothecary shelf of books and vessels (lifted from lantern-water's
 * `world.js` `shelf`): the carcass, side stiles, shelves stocked from the
 * placement's random stream with leather-bound books (brass bands and a canvas
 * label) or turned vessels, the crown mouldings, and on a wide shelf three rows
 * of six labelled drawers with brass pulls. Origin: the shelf's (x, z) on the
 * floor, its front toward +z. Params: `width` (3.2), `height` (3.5).
 * The vessels' variants count up within this shelf (`world.js` `bottleIndex`).
 */
import * as THREE from 'three';
import { apothecaryVessel } from '../apothecary.ts';
import { num } from '../kit.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'shop_shelf',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { m } = ctx;
    const r = ctx.random;
    const width = num(ctx, 'width', 3.2);
    const height = num(ctx, 'height', 3.5);
    let bottleIndex = 0;
    ctx.box(root, 0, height / 2, 0, width, height, 0.55, m.darkWood);
    for (const s of [-1, 1]) ctx.box(root, s * (width / 2 - 0.07), height / 2, 0.38, 0.14, height, 0.2, m.wood);
    const books = [m.book1, m.book2, m.book3];
    for (let y = width > 3 ? 1.3 : 0.3; y < height - 0.65; y += 0.7) {
      ctx.box(root, 0, y, 0.28, width, 0.12, 0.83, m.wood);
      for (let xx = -width * 0.43; xx < width * 0.4; xx += 0.3 + r() * 0.08) {
        const h = 0.23 + r() * 0.3;
        if (r() < 0.36) {
          ctx.box(root, xx, y + 0.08 + h / 2, 0.38, 0.13, h, 0.27, books[Math.floor(r() * 3)] ?? m.book1);
          for (const yy of [y + 0.13, y + h + 0.025]) ctx.box(root, xx, yy, 0.523, 0.11, 0.018, 0.024, m.brass);
          ctx.box(root, xx, y + h * 0.62 + 0.08, 0.525, 0.055, 0.1, 0.022, m.canvas);
        } else {
          const size = 0.23 + r() * 0.08;
          apothecaryVessel(ctx.kit, root, xx, y + 0.08, 0.38, size, bottleIndex);
          bottleIndex += 1;
        }
      }
    }
    ctx.box(root, 0, height + 0.09, 0.16, width + 0.25, 0.18, 0.85, m.wood);
    ctx.box(root, 0, height + 0.21, 0.2, width + 0.4, 0.08, 0.98, m.darkWood);
    if (width > 3) {
      for (let row = 0; row < 3; row += 1) {
        for (let col = 0; col < 6; col += 1) {
          const xx = -width * 0.42 + col * width * 0.168;
          const yy = 0.24 + row * 0.37;
          ctx.box(root, xx, yy, 0.53, width * 0.152, 0.33, 0.14, m.wood);
          ctx.box(root, xx, yy + 0.02, 0.613, 0.18, 0.085, 0.015, m.canvas);
          ctx.cylinder(root, xx, yy - 0.08, 0.66, 0.026, 0.045, m.brass).rotation.x = Math.PI / 2;
        }
      }
    }
    return { root };
  },
};
